const env = import.meta.env;

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || '',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: env.VITE_FIREBASE_PROJECT_ID || '',
  appId: env.VITE_FIREBASE_APP_ID || '',
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
};

/** The KOVIO API server (the wedding layer lives under /api/web on it). No trailing slash. */
export const API_URL = String(env.VITE_API_URL || '').replace(/\/+$/, '');

const ready = !!(API_URL && firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);
const forced = String(env.VITE_BACKEND || '').toLowerCase();

/** "api" uses the KOVIO API server and Firebase sign-in; "demo" keeps everything in this browser. */
export const BACKEND: 'api' | 'demo' = forced === 'demo' ? 'demo' : forced === 'api' || ready ? 'api' : 'demo';

export const USE_EMULATORS = String(env.VITE_USE_EMULATORS || '') === 'true';

/** The public address of the app, used for share links and QR codes. */
export const APP_URL = String(env.VITE_APP_URL || (typeof location !== 'undefined' ? location.origin : 'https://kovio.ng')).replace(/\/+$/, '');
export const APP_HOST = APP_URL.replace(/^https?:\/\//, '');

/** With a Google Maps Embed API key, venue sections show Google's live map. Without one, they show a drawn map that opens Google Maps. */
export const MAPS_EMBED_KEY = String(env.VITE_GOOGLE_MAPS_EMBED_KEY || '');
